import createReducer from 'reducers/createReducer';

import { Payment } from 'actions/actionTypes';

const INITIAL_STATE = { 
    chargesPaymentType: '',
    currency: 'KRW',
    totalEstimatedCharges: 0,
    charges: [],

    paymentMethodType: '',
    paymentGatewayRequest: {
        isOpen: false,
        script: '',
        html: ''
    },

    paymentDate: {
        manualPayment:{
            startDay: 0,
            endDay: 0,
        },
        prepayment:{
            startDay: 0,
            endDay: 0,
        },
        automaticPayment:{
            cycle: '',
            month: 0,
            day: 0,
        },
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Payment.CHANGE_CHARGES_PAYMENT_TYPE]: (state, action) => {
        state.currency = INITIAL_STATE.currency;
        state.totalEstimatedCharges = INITIAL_STATE.totalEstimatedCharges;
        state.charges = INITIAL_STATE.charges;

        state.chargesPaymentType = action.payload;
    },
    [Payment.CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN]: (state, action) => state.paymentGatewayRequest.isOpen = true,

    [Payment.LOAD_SHOP_CHARGES_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Payment.LOAD_SHOP_CHARGES_REQUEST_SUCCESS]: (state, action) => {
        state.currency = action.payload.currency;
        state.totalEstimatedCharges = action.payload.totalEstimatedCharges;
        state.charges = action.payload.charges;
    },
    [Payment.LOAD_SHOP_CHARGES_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };

    },

    [Payment.LOAD_PAYMENT_DATE_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Payment.LOAD_PAYMENT_DATE_REQUEST_SUCCESS]: (state, action) => {
        state.paymentDate.manualPayment.startDay = action.payload.manualPaymentDate.startDay;
        state.paymentDate.manualPayment.endDay = action.payload.manualPaymentDate.endDay;

        state.paymentDate.prepayment.startDay = action.payload.automaticPaymentDate.prepaymentDate.startDay;
        state.paymentDate.prepayment.endDay = action.payload.automaticPaymentDate.prepaymentDate.endDay;
        
        state.paymentDate.automaticPayment.cycle = action.payload.automaticPaymentDate.cycle;
        state.paymentDate.automaticPayment.month = action.payload.automaticPaymentDate.month;
        state.paymentDate.automaticPayment.day = action.payload.automaticPaymentDate.day;
    },
    [Payment.LOAD_PAYMENT_DATE_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },

    [Payment.SHOP_CHARGES_PAYMENT_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.paymentMethodType = action.payload;
    },
    [Payment.SHOP_CHARGES_PAYMENT_REQUEST_SUCCESS]: (state, action) => {
        state.paymentGatewayRequest.script = action.payload.script;
        state.paymentGatewayRequest.html = action.payload.html;
    },
    [Payment.SHOP_CHARGES_PAYMENT_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };

    },
});


export default reducer;